import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Drawer, DrawerProps } from 'antd';

import { useBrandsSlice } from 'entities/Brand';
import { ButtonsBar, OfferDetail } from 'entities/Offer';
import { useDisableBodyScroll } from 'shared/hooks';

interface IOfferDetailDrawerProps extends DrawerProps {}

export const OfferDetailDrawer: FC<IOfferDetailDrawerProps> = ({ ...props }) => {
	const { t } = useTranslation();

	const { openedOffer, setOpenedOffer } = useBrandsSlice();
	const offer = openedOffer?.offer;
	const brand = openedOffer?.brand;

	useDisableBodyScroll(!!openedOffer);

	if (!offer) return null;

	return (
		<Drawer
			{...props}
			open={!!openedOffer}
			onClose={() => setOpenedOffer(null)}
			width={650}
			title={t('Детали оффера')}
			extra={<ButtonsBar brand={brand} offer={offer} />}>
			<OfferDetail offer={offer} brand={brand} />
		</Drawer>
	);
};
